// src/components/Header.tsx
import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { useTheme } from '@mui/material/styles';

const Header: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [drawerOpen, setDrawerOpen] = useState(false);

  const menuItems = [
    { label: 'SERVICES', targetId: 'services' },
    { label: 'INSIGHTS', targetId: 'insights' },
    { label: 'ABOUT SyncLogistic', targetId: 'bti' },
    { label: 'CONTACT US', targetId: 'contact-banner' },
  ];

  const handleScroll = (id: string) => {
    if (!id) return;
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
    setDrawerOpen(false); // Close drawer on nav click
  };

  return (
    <>
      {/* Top info bar */}
      <Box
        onClick={() => handleScroll('contact-banner')}
        sx={{
          backgroundColor: '#f5f5f5',
          color: '#333',
          py: 0.5,
          cursor: 'pointer',
        }}
      >
        <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <MailOutlineIcon sx={{ fontSize: 14, pr: 0.5, pt: 0.4 }} />
          <Typography variant="caption" sx={{ fontFamily: 'Open Sans, sans-serif' }}>
            SyncLogistic | Global Logistic Consulting Firm
          </Typography>
        </Container>
      </Box>

      {/* Main Nav */}
      <AppBar position="sticky" elevation={0} sx={{ backgroundColor: 'white', color: '#0d1b2a' }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, fontSize: '1.25rem', fontFamily: 'Open Sans, sans-serif' }}
          >
            SyncLogistic
          </Typography>

          {isMobile ? (
            <>
              <IconButton onClick={() => setDrawerOpen(true)} edge="end">
                <MenuIcon />
              </IconButton>
              <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
                <List sx={{ width: 220 }}>
                  {menuItems.map(({ label, targetId }) => (
                    <ListItem {...({ button: true, key: label, onClick: () => handleScroll(targetId) } as any)}>
                      <ListItemText primary={label} />
                    </ListItem>
                  ))}
                </List>
              </Drawer>
            </>
          ) : (
            <Box>
              {menuItems.map(({ label, targetId }) => (
                <Button
                  key={label}
                  onClick={() => handleScroll(targetId)}
                  sx={{
                    color: '#0d1b2a',
                    fontWeight: 600,
                    fontFamily: 'Open Sans, sans-serif',
                    borderBottom: '2px solid transparent',
                    borderRadius: 0,
                    mx: 1,
                    transition: 'border-bottom 0.3s ease-in-out',
                    '&:hover': {
                      borderBottom: '2px solid #0d1b2a',
                    },
                  }}
                >
                  {label}
                </Button>
              ))}
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Header;
